export var Entitlement;
(function (Entitlement) {
    Entitlement["ACCESS_POLICY"] = "Platform.AccessPolicy";
    Entitlement["APP_TEST_DEVELOPER"] = "Ubl.AppTestDevNamedUser";
    Entitlement["APP_TESTER"] = "Ubl.AppTesterNamedUser";
    Entitlement["CHECK_ACCESS"] = "Platform.CheckAccess";
    Entitlement["CUSTOM_MAIL_SETTINGS"] = "Platform.CustomMailSettings";
    Entitlement["CUSTOMER_MANAGED_KEY"] = "Platform.CustomerManagedKey";
    Entitlement["INSIGHTS"] = "Insights.FullMode";
    Entitlement["IPRESTRICTION"] = "Platform.IpRestrictions";
    Entitlement["SAP"] = "Platform.SapEnabled";
    Entitlement["SESSION_POLICY"] = "Platform.SessionPolicy";
    Entitlement["SSO_PROVISIONING"] = "Platform.SSOProvisioning";
    Entitlement["USER_CONSENT"] = "Platform.UserConsentPolicy";
})(Entitlement || (Entitlement = {}));
